import { render, staticRenderFns } from "./PermissionExplainer.vue?vue&type=template&id=43e4c444&lang=pug&"
import script from "./PermissionExplainer.vue?vue&type=script&lang=js&"
export * from "./PermissionExplainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports